/**
 * Redact the personal RTS token from analytics/error payloads.
 *
 * The token lives in the URL path (`/rts/<token>`, optional locale prefix).
 * Kinesis logging intentionally keeps the full URL; this helper is for the
 * third-party analytics/error SDKs.
 */
const RTS_TOKEN_PATH = /(\/(?:(?:en|fr|de|it|ru|es-la|pt-br)\/)?rts\/)[^/?#]+/g;

export function redactRtsUrl(value) {
  if (typeof value !== "string") return value;
  return value.replace(RTS_TOKEN_PATH, "$1[redacted]");
}

const POSTHOG_URL_KEYS = [
  "$current_url",
  "$pathname",
  "$referrer",
  "$initial_current_url",
  "$initial_pathname",
  "$initial_referrer",
  "$session_entry_url",
  "$prev_pageview_pathname",
  "$prev_pageview_url",
];

export function redactPostHogProperties(properties) {
  if (!properties || typeof properties !== "object") return properties;
  for (const key of POSTHOG_URL_KEYS) {
    if (typeof properties[key] === "string") {
      properties[key] = redactRtsUrl(properties[key]);
    }
  }
  return properties;
}

function redactMetadata(metadata) {
  if (!metadata || typeof metadata !== "object") return;
  for (const key of Object.keys(metadata)) {
    if (typeof metadata[key] === "string") {
      metadata[key] = redactRtsUrl(metadata[key]);
    }
  }
}

export function redactBugsnagEvent(event) {
  if (!event || typeof event !== "object") return event;

  if (event.request && typeof event.request === "object") {
    if (typeof event.request.url === "string") {
      event.request.url = redactRtsUrl(event.request.url);
    }
    if (typeof event.request.referrer === "string") {
      event.request.referrer = redactRtsUrl(event.request.referrer);
    }
  }

  if (typeof event.context === "string") {
    event.context = redactRtsUrl(event.context);
  }

  redactMetadata(event.metadata);
  redactMetadata(event.metaData);

  if (Array.isArray(event.breadcrumbs)) {
    for (const crumb of event.breadcrumbs) {
      redactMetadata(crumb?.metadata);
      redactMetadata(crumb?.metaData);
    }
  }

  return event;
}
